module.exports = __webpack_public_path__ + "static/media/Quality-assurance.71525405.png";